<template>
  <div class="menu-derecha" v-bind:class="{ 'abreElMenu': existeAlgunMenuSeleccionado, 'cierraElMenu': !existeAlgunMenuSeleccionado }">
    <ul class="pl-0">
      <li v-for="menu in menus" v-bind:key="menu.MenuId" v-bind:class="{ 'menu-lateral-activo': menu.Mostrar }" class="pestanas">
        <h2 v-on:click="menu.Mostrar = !menu.Mostrar" @mouseover="CerrarLosMenusQueNoSeMuestren(menu.MenuId)" class="enMayusculas">{{menu.Titulo}}&nbsp;
          <i v-if="menu.Mostrar == true" class="fas fa-caret-down pt-2"></i>
          <i v-else class="fas fa-caret-up pt-2"></i>
        </h2>
      </li>
    </ul>
    <div v-for="menu in menus" v-bind:key="'panel' + menu.MenuId" class="panel" v-bind:class="{ 'menu-lateral-activo-panel': menu.Mostrar }" >
      <div v-if="EstaVacioLosDatos()" class="menu-derecha-cargando">
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
      <div v-else-if="!EstaVacioLosDatos() && datos[menu.MenuId] != null && datos[menu.MenuId] != undefined && datos[menu.MenuId].SiHayError == true" class="menu-derecha-cargando">
        <h3>Pagina web en mantenimiento</h3>
      </div>
      <div class="seccionCompleta" v-else-if="!EstaVacioLosDatos() && datos[menu.MenuId].length > 0">
        <div v-for="datoPin in datos[menu.MenuId]" v-bind:key="'pin-' + datoPin.ContenidoDeLaPaginaWebId">
          <a class="tituloDeLaSeccion" v-if="datoPin.EsPin == true && datoPin.ArchivosDeContenidoDeLaPaginaWeb.length > 0" v-on:click="AbrirDocumento(ObtenLaRutaDeDescarga(datoPin.ArchivosDeContenidoDeLaPaginaWeb), '_self');">
            <h3><i class="fas fa-thumbtack">&nbsp;</i>{{datoPin.Titulo}}</h3>
          </a>
          <a class="tituloDeLaSeccion" v-else-if="datoPin.EsPin == true && datoPin.Vinculo == null">
            <h3><i class="fas fa-thumbtack">&nbsp;</i>{{datoPin.Titulo}}</h3>
          </a>
          <a class="tituloDeLaSeccion" v-else-if="datoPin.EsPin == true && datoPin.Vinculo.includes('http')" v-on:click="AbrirDocumento(datoPin.Vinculo, '_blank');">
            <h3><i class="fas fa-thumbtack">&nbsp;</i>{{datoPin.Titulo}}</h3>
          </a>
          <router-link class="tituloDeLaSeccion" v-else-if="datoPin.EsPin == true" :to="datoPin.Vinculo">
            <h3><i class="fas fa-thumbtack">&nbsp;</i>{{datoPin.Titulo}}</h3>
          </router-link>
        </div>
        <div class="informacionDeLaSeccion conBarraParaDesplazar" v-bind:class="{ 'informacionDeLaSeccionSinTitulo': NoExistePinDeLaSeccion(menu.MenuId)}">
          <div v-for="dato in datos[menu.MenuId]" v-bind:key="'info-' + dato.ContenidoDeLaPaginaWebId">
            <!-- <a v-if="dato.ArchivosDeContenidoDeLaPaginaWeb.length > 0" v-on:click="AbrirDocumento(ObtenLaRutaDeDescarga(dato.ArchivosDeContenidoDeLaPaginaWeb), '_self');">
              <h3 v-if="dato.EsPin == false">{{dato.Titulo}}</h3>
              <img :src="dato.RutaDeImagen" />
              <p>{{dato.TextoDelContenido}}</p>
            </a> -->
            <a v-if="dato.ArchivosDeContenidoDeLaPaginaWeb.length > 0" v-on:click="AbreElVisor(ObtenLaRutaDeDescarga(dato.ArchivosDeContenidoDeLaPaginaWeb));">
              <h3 v-if="dato.EsPin == false">{{dato.Titulo}} </h3>
              <img :src="dato.RutaDeImagen" />
              <p>{{dato.TextoDelContenido}}</p>
            </a>
            <a v-else-if="dato.Vinculo == null">
              <h3 v-if="dato.EsPin == false">{{dato.Titulo}}</h3>
              <img :src="dato.RutaDeImagen" />
              <p>{{dato.TextoDelContenido}}</p>
            </a>
            <a v-else-if="dato.Vinculo.includes('http')" v-on:click="AbrirDocumento(dato.Vinculo, '_blank');">
              <h3 v-if="dato.EsPin == false">{{dato.Titulo}}</h3>
              <img :src="dato.RutaDeImagen" />
              <p>{{dato.TextoDelContenido}}</p>
            </a>
            <router-link v-else :to="dato.Vinculo">
              <h3 v-if="dato.EsPin == false">{{dato.Titulo}}</h3>
              <img :src="dato.RutaDeImagen" />
              <p>{{dato.TextoDelContenido}}</p>
            </router-link>
          </div>
        </div>
      </div>
      <router-link :to="menu.RutaParaAccesar" class="pieDeLaSeccion text-center">
        <h3 class="ver-mas">Ver mas</h3>
      </router-link>
    </div>
  </div>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import api from "@/../static/js/api";
import axios from "axios";
import comun from "@/../static/js/comun";

export default {
    data() {
        return {
            enumeraciones,
            enumeraciones_sicpo,
            PAGINA_DE_INICIO: 1,
            TIPO_POSICION: 4,
            TIPO_ROL_DE_ARCHIVO: 1,
            menus: [],
            datos: {},
            nombreDeVariableDelComponente: "cargoMenuDerecho"
        };
    },
    computed: {
      existeAlgunMenuSeleccionado: function() {
        let seAbreElMenu = false; 

        if(this.menus.length > 0) {
          this.menus.forEach(menu => {
            if(menu.Mostrar == true)
              seAbreElMenu = true;
          })
        }

        return seAbreElMenu;
      }
    },
    methods: {
          AbreElVisor: function(vinculo) {
          //  console.log("vinculo:::",vinculo)
           // comun.DescargarDocumentoPDF(vinculo)//-->>cambio para descargar desde pagina
            this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,'\\\\themisfstest'));
      },
        CargaElMenu: function() {
            let parametros = {
                EsPrueba: this.enumeraciones.EsPrueba, 
                PaginaDeInicioId: this.PAGINA_DE_INICIO, 
                TipoPosicionId: this.TIPO_POSICION
            }

            axios
                .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosMenusYSubmenusDeLaPaginaOficial, parametros)
                .then(respuesta => {
                if (respuesta.data.SiHayError) {
                    console.error(respuesta.data);
                    this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
                } else {
                    this.menus = respuesta.data.Menus;

                    this.menus.forEach(menu => {
                      this.CargaLosComunicados(menu.MenuId);
                    })
                    this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
                }
            })
            .catch(excepcion => {
                console.error(excepcion);
                this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
            });
        },
        CargaLosComunicados: function(menuId) {
            const parametros = {
                EsPrueba: this.enumeraciones.EsPrueba, 
                MenuId: menuId
            };

            axios
                .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosComunicadosDeLaPaginaOficial, parametros)
                .then(respuesta => {
                    if (respuesta.data.SiHayError) {
                      console.error(respuesta.data.Error);
                      this.datos[menuId] = respuesta.data;
                    } else {
                      this.datos[menuId] = respuesta.data.ComunicadosDePaginaWeb;
                    }
                })
                .catch(excepcion => {
                    console.error(excepcion);
                    this.datos[menuId] = {
                      SiHayError: true
                    }
                });
        }, 
        EstaVacioLosDatos: function() {
          return Object.keys(this.datos).length === 0 ? true : false;
        }, 
        CerrarLosMenusQueNoSeMuestren: function(menuId) {
          if(this.menus.length > 0) {
            this.menus.forEach(menu => {
              if(menu.MenuId != menuId)
                menu.Mostrar = false;

              if(menu.MenuId == menuId)
                menu.Mostrar = true;
            })
          }
        },
        NoExistePinDeLaSeccion: function(menuId) {
          let noExistePin = true
          if(this.datos[menuId].length > 0)
            this.datos[menuId].forEach(dato => {
              if(dato.EsPin == true)
                noExistePin = false;
            })

          return noExistePin;
        },
        ObtenLaRutaDeDescarga: function(archivos) {
          let rutaDeDescarga = "";

          if(archivos != null && archivos != undefined && archivos.length > 0)
            archivos.forEach(archivo => {
              if(this.TIPO_ROL_DE_ARCHIVO == archivo.TipoRolDeArchivoEnContenido.TipoRolDeArchivoEnContenidoId)
                rutaDeDescarga = archivo.RutaDeArchivoCarpeta;
            });

          return rutaDeDescarga;
        },
        YaTermineDeCargar: function(estatus) {
          this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, estatus);
        }, 
        AbrirDocumento: function(vinculo, formaDeApertura) {
          comun.DescargarDocumentoPDF(vinculo)
         // window.open(vinculo, formaDeApertura);
        }
    }, 
    mounted() {
      this.CargaElMenu();
    }
}
</script>

<style scoped>
.seccionCompleta {
  height: 95%;
}

.tituloDeLaSeccion {
  height: 15%;
}

.informacionDeLaSeccion {
  height: 90%;
}

.informacionDeLaSeccionSinTitulo {
  height: 98% !important;
}

.pieDeLaSeccion {
  height: 5%;
}

.enMayusculas {
  text-transform: uppercase;
}

.menu-lateral-activo {
  background-color: rgba(0, 0, 0, 0.95) !important;
  margin-left: 0 !important;
}

.abreElMenu {
  width: 20vw !important;
}

.cierraElMenu {
  width: 39px !important;
}

.menu-lateral-activo-panel {
  margin-right: 2.1vw !important;
  z-index: 10;
}

.menu-derecha ul {
  transform: rotate(180deg);
  border: 0;
  margin-right: 0 !important;
  z-index: 9;
  width: 100%;
}

.menu-derecha .panel {
  height: calc(100vh - 86px);
  max-height: calc(100vh - 86px);
  background-color: rgba(0, 0, 0, 0.7);
  width: 18vw;
  position: absolute;
  right: 0;
  top: 0;
  margin-right: -18vw;
  transition: 1s all;
  padding: 20px;
  padding-right: 0;
  overflow: hidden;
}

  .menu-derecha ul li {
    margin-right: 0 !important;
  }

.menu-derecha .panel div {
  width: 100%;
}

.menu-derecha .panel div div {
  width: 100%;
  padding-right: 20px;
}

.conBarraParaDesplazar {
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0px !important;
}

.menu-derecha .panel div div a {
  width: 100%;
}

.menu-derecha .panel div div div a {
  width: 100%;
}

.menu-derecha li {
  writing-mode: vertical-rl;
  list-style: none;
  transform: skewy(20deg);
  background-color: #be9a5e;
  transition: 1s all;
}

.menu-derecha-cargando {
  width: 100%;
  font-size: 10em;
  height: calc(100vh - 200px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-derecha-cargando h3 {
  text-orientation: sideways;
  padding: 40px 10px;
  margin: 0;
  cursor: pointer;
  font-size: 0.32em !important;
}

.menu-derecha h2 {
  text-orientation: sideways;
  padding: 40px 10px;
  margin: 0;
  transform: skewy(-20deg);
  cursor: pointer;
  font-size: 16px;
}

.menu-derecha {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  width: 2vw;
  transition: opacity 1s, width 1s;
}

.menu-derecha img {
  width: 100%;
}

.menu-derecha a {
  color: #fff;
}

.menu-derecha a i {
  font-size: 0.8em !important;
}

.menu-derecha h3 {
  font-size: 1.6em;
}

.menu-derecha p {
  text-align: justify;
}

.ver-mas {
  color: #be9a5e;
}

/* Microsoft Edge Browser 12+ (All) - one-liner method */
_:-ms-lang(x), _:-webkit-full-screen, .pestanas 
{ 
 
    height: 200px;
  
}
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaPrincipal/MenuDerecha.vue